<ng-template #customEleTemplate>
	<div class="customContentWrapper">
		<div class="top">
			<div class="logo"></div>
			<div class="title">收集個人資料通知</div>
		</div>
		<div class="bottom">
			<div *ngIf="datas.getLang() == 'tc'" class="content">
				我們需要您的同意，以便收集您的個人資料，包括聲音和文字等，以提供給第三方。這些數據將用於改善我們的服務和用戶體驗。這些數據將被安全地處理和儲存。
				<ul>
					<li>用途：您的數據僅用於提供和增強我們的服務功能，並不會用於其他用途。</li>
					<li>第三方分享：我們承諾不會將您的資料出售或轉讓給任何未經授權的第三方，並會遵循相關的隱私法規。</li>
				</ul>
				請確認您同意我們進行這些數據收集。您可以隨時查看我們的<span class="link" (click)="openUrl('https://www.rainbowone.hk/tc')">隱私政策</span>以了解更多信息。
			</div>
			<div *ngIf="datas.getLang() == 'sc'" class="content">
				我们需要您的同意，以便收集您的个人资料，包括声音和文字等，以提供给第三方。这些数据将用于改善我们的服务和用户体验。这些数据将被安全地处理和储存。
				<ul>
					<li>用途：您的数据仅用于提供和增强我们的服务功能，并不会用于其他用途。</li>
					<li>第三方分享：我们承诺不会将您的资料出售或转让给任何未经授权的第三方，并会遵循相关的隐私法规。</li>
				</ul>
				请确认您同意我们进行这些数据收集。您可以随时查看我们的<span class="link" (click)="openUrl('https://www.rainbowone.hk/tc')">隐私政策</span>以了解更多信息。
			</div>
			<div *ngIf="datas.getLang() == 'en'" class="content">
				We need your consent to collect your personal data, including voice and text, which we may provide to third parties. This data will be used to improve our services and user experience. This data will be processed and stored securely.
				<ul>
					<li>Purpose: Your data will only be used to provide and enhance our service functionality and will not be used for any other purpose.</li>
					<li>Third-Party Sharing: We promise not to sell or transfer your data to any unauthorized third party and will comply with relevant privacy regulations.</li>
				</ul>
				Please confirm that you consent to our collection of this data. You can review our <span class="link" (click)="openUrl('https://www.rainbowone.net/tc')">Privacy Policy</span> at any time for more information.
			</div>

		</div>

	</div>
</ng-template>
<user-menu #userMenu style="display: none;"></user-menu>